import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAgenteGet = async (credentials, data) => {
  const body = {
    service: "RNHAgenteGet",
    params: {
      rnhAgenteId: data?.agenteId || '',
      rnhEstablecimientoCod: data?.establecimientoCod || '',
      rnhAgenteEstablecimientoEstructuraCod: data?.estructuraCod || '',
      rnhTipoComponenteCod: data?.tipoComponenteCod || '',
      rnhCargoCod: data?.cargoCod || '',
      rnhConvenioCod: data?.convenioCod || '',
      rnhAgenteStatus: data?.agenteStatus || '',
      // 'Y' -> el back devuelve solo los ACTIVOS y SIN asignar a ningun nodo, que
      // es el universo de lo que se puede asignar desde el organigrama.
      soloDisponibles: data?.soloDisponibles || '',
      usuarioNroDeDocumentoX: data?.nroDocumento || '',
      usuarioApellidos: data?.apellidos || '',
      page: data?.page ?? null,
      pageSize: data?.pageSize ?? null
    }
  }

  return respuestaDe(await axiosPost(body, credentials));
}
